import React, { useEffect, useState, useContext } from "react";
import { Data } from "./App";
import Heart from "./Heart";

const styleSortOrder = ["ローソファ", "ハイバックソファ", "プレミアムソファ", "ミドルバックソファ"];

export default function Filter() {
  const { rawData, data, setData, favList, favFilter, setFavFilter } =
    useContext(Data);
  const [styleFilter, setStyleFilter] = useState("");
  const [sizeFilter, setSizeFilter] = useState(
    window.location.search.includes("bookmark") ? "" : "three_piece"
  );
  // const [typeFilter, setTypeFilter] = useState("");
  const [minWidth, setMinWidth] = useState();
  const [maxWidth, setMaxWidth] = useState();
  const [minPrice, setMinPrice] = useState();
  const [maxPrice, setMaxPrice] = useState();
  const [sortType, setSortType] = useState("style");
  // シリーズ一覧
  const styleList = {
    ローソファ: "ローソファ",
    ハイバックソファ: "ハイバックソファ",
    プレミアムソファ: "プレミアムソファ",
    ミドルバックソファ: "ミドルバックソファ",
  };
  // サイズ一覧
  const sizeList = {
    three_piece: "3人掛け",
    two_piece: "2人掛け",
    one_piece: "1人掛け",
    couch: "カウチソファ",
    corner: "コーナーソファ",
    ottoman: "オットマン",
  };
  // ソファタイプのoption
  // const typeList = [
  //   "カバーリングソファ",
  //   "ローソファ",
  //   "ハイバックソファ",
  //   "コンパクトソファ",
  // ];
  // 価格のoption
  const priceList = [
    50000, 100000, 150000, 200000, 300000, 400000, 500000, 600000, 700000,
    800000, 900000, 1000000,
  ];
  // 幅のoption
  const widthList = [1200, 1500, 1800, 2100, 2400, 2700, 3000];

  // お気に入り表示切り替え
  const favToggle = () => {
    favFilter === true ? setFavFilter(() => false) : setFavFilter(() => true);
  };
  // 価格・幅選択
  const setMin = (e) => {
    if (e.target.name === "price") {
      setMinPrice(() => e.target.value);
    } else if (e.target.name === "width") {
      setMinWidth(() => e.target.value);
    }
  };
  const setMax = (e) => {
    if (e.target.name === "price") {
      setMaxPrice(() => e.target.value);
    } else if (e.target.name === "width") {
      setMaxWidth(() => e.target.value);
    }
  };

  useEffect(() => {
    let data = rawData;
    // シリーズ
    if (styleFilter !== "") {
      data = data.filter((item) => item.style.includes(styleFilter));
    }
    // サイズ
    if (sizeFilter !== "") {
      data = data.filter((item) => item.category.includes(sizeFilter));
    }
    // タイプ
    // if (typeFilter !== "") {
    //   data = data.filter((item) => item.type.includes(typeFilter));
    // }
    // 価格
    if (minPrice > 49999) {
      data = data.filter((item) => item.minprice >= Number(minPrice));
    }
    if (maxPrice > 49999) {
      data = data.filter((item) => item.minprice <= Number(maxPrice));
    }
    // 幅
    if (minWidth > 0) {
      data = data.filter((item) => item.w >= Number(minWidth));
    }
    if (maxWidth > 0) {
      data = data.filter((item) => item.w <= Number(maxWidth));
    }
    // お気に入り
    if (favFilter) {
      if (favList.length > 0) {
        data = favList
          .map((fav) => {
            return data.filter((item) => {
              return item.code === fav;
            });
          })
          .flat();
      } else {
        data = [];
      }
    }
    // 並べ替え処理
    if (sortType === "style") {
      data.sort((a, b) => {
        // Find the index in your custom styleSortOrder array
        const indexA = styleSortOrder.indexOf(a.style);
        const indexB = styleSortOrder.indexOf(b.style);

        // Sort based on the index position (0, 1, 2, 3...)
        if (indexA !== -1 && indexB !== -1 && indexA !== indexB) {
          return indexA - indexB;
        }

        // If a style isn't in the list, move it to the end
        if (indexA === -1 && indexB !== -1) return 1;
        if (indexA !== -1 && indexB === -1) return -1;

        // If styles are the same, secondary sort by ID (as per your SQL)
        return a.id - b.id;
      });
    } else if (sortType === "priceUp") {
      data = data.sort((a, b) => {
        return a.minprice - b.minprice;
      });
    } else if (sortType === "priceDn") {
      data = data.sort((a, b) => {
        return b.minprice - a.minprice;
      });
    }
    setData(() => data.slice());
  }, [
    rawData,
    favList,
    favFilter,
    styleFilter,
    sizeFilter,
    // typeFilter,
    minWidth,
    maxWidth,
    minPrice,
    maxPrice,
    sortType,
  ]);

  return (
    <>
      <div className="title">
        <h1 className="en">NOYES All Sofa</h1>
        <p>全ソファ一覧</p>
      </div>

      <div className="filter">
        <ul>
          <li>
            <p>スタイル</p>
            <div className="select_box">
              <select
                value={styleFilter}
                onChange={(e) => setStyleFilter(e.target.value)}
              >
                <option value="">全て</option>
                {Object.keys(styleList).map((item, index) => {
                  return (
                    <option value={item} key={index}>
                      {styleList[item]}
                    </option>
                  );
                })}
              </select>
            </div>
          </li>
          <li>
            <p>サイズ</p>
            <div className="select_box">
              <select
                value={sizeFilter}
                onChange={(e) => setSizeFilter(e.target.value)}
              >
                <option value="">全て</option>
                {Object.keys(sizeList).map((item, index) => {
                  return (
                    <option value={item} key={index}>
                      {sizeList[item]}
                    </option>
                  );
                })}
              </select>
            </div>
          </li>
          <li>
            {/* <p>タイプ</p>
            <div className="select_box">
              <select
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}
              >
                <option value="">---</option>
                {typeList.map((item, index) => {
                  return (
                    <option value={item} key={index}>
                      {item}
                    </option>
                  );
                })}
              </select>
            </div> */}
          </li>
          <li>
            <p>幅</p>
            <div className="scoped_select">
              <div className="select_box">
                <select name="width" onChange={setMin} value={minWidth}>
                  <option value="">---</option>
                  {widthList.map((item, index) => {
                    return (
                      <option key={index} value={item}>
                        {Number(item).toLocaleString()}mm
                      </option>
                    );
                  })}
                </select>
              </div>
              〜
              <div className="select_box">
                <select name="width" onChange={setMax} value={maxWidth}>
                  <option value="">---</option>
                  {widthList.map((item, index) => {
                    return (
                      <option key={index} value={item}>
                        {Number(item).toLocaleString()}mm
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </li>
          <li>
            <p>価格</p>
            <div className="scoped_select">
              <div className="select_box">
                <select name="price" onChange={setMin} value={minPrice}>
                  <option value="">---</option>
                  {priceList.map((item, index) => {
                    return (
                      <option key={index} value={item}>
                        {Number(item).toLocaleString()}円
                      </option>
                    );
                  })}
                </select>
              </div>
              〜
              <div className="select_box">
                <select name="price" onChange={setMax} value={maxPrice}>
                  <option value="">---</option>
                  {priceList.map((item, index) => {
                    return (
                      <option key={index} value={item}>
                        {Number(item).toLocaleString()}円
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </li>
          <li className="pc">
            <span></span>
            <div>
              <small>検索結果</small>
              <span className="en">{data.length}</span>件
            </div>
          </li>
        </ul>
      </div>

      <div className="border_box">
        <div className="list_count sp">
          <small>検索結果</small>
          <span className="en">{data.length}</span>件
        </div>
        <p className="tax_postage sp">すべて税込・送料無料</p>
        <div className="border"></div>
        <p className="tax_postage pc">すべて税込・送料無料</p>
        <div className="fav_sort">
          <label
            style={{
              backgroundColor: favFilter
                ? "rgba(150,150,150,0.1)"
                : "transparent",
            }}
          >
            <Heart fill={"#1c1c1c"} size={15} />
            <p>お気に入り</p>
            <input
              type="checkbox"
              onChange={favToggle}
              checked={favFilter ? true : false}
              style={{ display: "none" }}
            />
          </label>
          <div className="sort_select">
            <b>並べ替え</b>
            <div className="sort_select_box">
              <select
                onChange={(e) => setSortType(e.target.value)}
                value={sortType}
              >
                <option value="style">スタイル順</option>
                <option value="priceUp">価格が安い順</option>
                <option value="priceDn">価格が高い順</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
